$(document).ready(function(){
    
  // Build a Box small print
  
  //$("#bxp-bldr-price_total").append("<div class='bbsmallprint discountsmallprint'>Discount automatically applied at check out.</div> ");
  //$("#bxp-bldr-bottom-wizard").append("<div class='bbsmallprint'>* Once you click <b>COMPLETE ORDER</b> and go to the cart, you will not be able to modify your bundle.</div> ");

  $(".bxp-details-price").text(function(index, text) { 
    return text.replace(':', ' '); 
  });

  $("body").on('DOMSubtreeModified', "#bxp-bldr-total_value", function() {
      setTimeout(function(){  
        $(".bxp-details-price").text(function(index, text) { 
        return text.replace(':', ' '); 
        });
      }, 500);
  });


    
  // Build a Box small print

  setTimeout(function(){  

    $(".rt-r-gap-4.justify-evenly button.rt-BaseButton").prop(":", "").fadeTo( "slow", 1 );

      
      $(".rt-r-gap-4.justify-evenly button.rt-BaseButton").html(function () {
          return $(this).html().replace(" $", "<span>$").replace(":", " "); 
      });

      $("span.rt-Text.rt-r-size-2.rt-r-weight-medium.bb-details__text-content--custom-color").html(function () {
          return $(this).html().replace(":", " ").replace("$", "<span>$"); 
      });

      $("button.rt-reset.rt-BaseButton.rt-r-size-2.rt-variant-solid.rt-high-contrast.rt-Button.bb-btn.bb-btn__primary--custom-color").html(function () {
          return $(this).html().replace(":", ""); 
      });
  
      $(".rt-r-fd-row").append("<div class='bbsmallprint discountsmallprint hide-on-mobile'>Discount automatically applied at check out.</div> ");
      $(".rt-r-fd-row").append("<div class='bbsmallprint hide-on-mobile'>* Once you click <b>COMPLETE ORDER</b> and go to the cart, you will not be able to modify your bundle.</div> ");
    
      $(".bxp-details-price").text(function(index, text) { 
        return text.replace(':', ' '); 
      });
    
  }, 4000);


  $("body").on('DOMSubtreeModified', ".bb-details__text-total--custom-color", function() {
      setTimeout(function(){  
       
      $("span.rt-Text.rt-r-size-2.rt-r-weight-medium.bb-details__text-content--custom-color").html(function () {
        //const found = $(this).html().match(/^(\$\d+.\d{2})$/);
        var price = $(this).html().substring($(this).html().indexOf("$"));
        
        if(price.indexOf("span")> -1){
          return; 
        } else {
          return $(this).html().replace(":", " ").replace("$", "<span>$"); 
        }
      });

      $("button.rt-reset.rt-BaseButton.rt-r-size-2.rt-variant-solid.rt-high-contrast.rt-Button.bb-btn.bb-btn__primary--custom-color").html(function () {
          return $(this).html().replace(":", " "); 
      });

      }, 100);
  });

 /* keep price from bouncing into button when search is used */
  $(".rt-TextFieldInput").on("input", function() {
    $(".rt-r-gap-4.justify-evenly button.rt-BaseButton").html(function () {
        return $(this).html().replace(" $", "<span>$").replace(":", " "); 
    });
  });

});